import React, { useEffect, useState } from 'react';
import { createUseStyles } from "react-jss";
import style from "./beds_style";
import { Dropdown } from 'react-bootstrap';
import Popup from '../popup/popup';
import { CreateBedForm } from '../forms/beds_create';
import { DetailBedForm } from '../forms/beds_details';
import { deleteBed, endRent } from '../../actions/beds';
import {useSelector} from "react-redux";

const useStyles = createUseStyles(style);

const STATUS_CONFIG = {
    EN_LOCATION: { label: 'En location', color: '#2980b9', bg: '#eaf3fb', icon: 'fa fa-bed' },
    SALE:        { label: 'Sale',         color: '#c0392b', bg: '#fdf3f2', icon: null },
    DISPONIBLE:  { label: 'Disponible',   color: '#27ae60', bg: '#eafaf1', icon: 'fa fa-check' },
};

const getEffectiveStatus = (element) => {
    if (element.status === 'SALE') return 'SALE';
    if (element.status === 'EN_LOCATION' || element.isRent) return 'EN_LOCATION';
    return 'DISPONIBLE';
};

const StatusBadge = ({ status }) => {
    const cfg = STATUS_CONFIG[status];
    return (
        <span style={{
            display: 'inline-block',
            padding: '2px 8px',
            borderRadius: 12,
            backgroundColor: cfg.bg,
            color: cfg.color,
            fontWeight: 'bold',
            fontSize: 11,
            border: `1px solid ${cfg.color}`,
        }}>
            {status === 'SALE' && '⚠ '}
            {cfg.label}
        </span>
    );
};

const BedsData = () => {
    const user = useSelector(state => state.user.user);
    const classes = useStyles();
    const [beds, setBeds] = useState([]);

    const [isOpenCreate, setIsOpenCreate] = useState(false);
    const [openDetail, setIsOpenDetail] = useState(null);

    const togglePopupCreate = () => {
        setIsOpenCreate(!isOpenCreate);
    }

    const togglePopupDetail = (bed) => {
        setIsOpenDetail(bed ? bed : null);
    }

    const deleteBedAction = (number) => {
        deleteBed(number);
        setBeds(beds.filter(element => element.number !== number));
    }

    const endRentAction = (number) => {
        endRent(number);
        setTimeout(function() {
            window.location.reload(false);
        }.bind(this), 1000)
    }

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/beds/`, {
            method: 'GET',
            credentials: 'include',
            headers: new Headers({
                'Content-Type': 'application/json',
            })
        })
            .then(async (res) => {
                if (res.status === 200) return res.json();
                throw await res.json();
            })
            .then((res) => {
                setBeds(res)
            }).catch((err) => {
                console.log(err)
            })
    }, []);

    const renderActionsMenu = (element, effectiveStatus) => (
        <Dropdown>
            <Dropdown.Toggle variant="outline-secondary" size="sm" id={`dropdown-${element.number}`}>
                ⋯
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item href={"/bed/" + element.number}>Modifier</Dropdown.Item>
                <Dropdown.Divider />
                {effectiveStatus === 'EN_LOCATION' && (
                    <Dropdown.Item onClick={() => endRentAction(element.number)}>
                        Fin de location
                    </Dropdown.Item>
                )}
                <Dropdown.Item className={classes.delete} onClick={() => deleteBedAction(element.number)}>
                    Supprimer
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );

    return (
        <div style={{ width: '100%', overflowX: 'hidden' }}>
            <div style={{ padding: '8px', maxWidth: 1400, margin: '0 auto' }} className="p-md-4">
                <div className="d-flex align-items-center justify-content-between mb-3 gap-2 flex-wrap">
                    <h2 className="d-none d-md-block" style={{ fontSize: 22, fontWeight: 'bold', margin: 0 }}>
                        Lits <span style={{ color: '#888', fontWeight: 'normal', fontSize: 16 }}>({beds.length})</span>
                    </h2>
                    {user.role === 'admin' && (
                        <button
                            type="button"
                            className="btn btn-dark col-12 col-md-auto"
                            onClick={togglePopupCreate}
                        >
                            + Ajouter un lit
                        </button>
                    )}
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                }}>
                    {beds.map((element) => {
                        const effectiveStatus = getEffectiveStatus(element);
                        const cfg = STATUS_CONFIG[effectiveStatus];
                        return (
                            <div
                                key={element.number}
                                style={{
                                    borderLeft: `4px solid ${cfg.color}`,
                                    borderRadius: 8,
                                    padding: '12px 14px',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: 8,
                                }}
                            >
                                <button
                                    className="btn btn-link p-0 text-start"
                                    style={{ flex: 1, minWidth: 0, textDecoration: 'none', color: 'inherit' }}
                                    onClick={() => togglePopupDetail(element)}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                                        <span style={{ fontWeight: 'bold', fontSize: 16 }}>
                                            Lit #{element.number}
                                        </span>
                                        <StatusBadge status={effectiveStatus} />
                                    </div>
                                    <div style={{ fontSize: 13, color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {element.client
                                            ? <><strong>{element.client}</strong>{element.pharmacy ? ` · ${element.pharmacy}` : ''}</>
                                            : <span style={{ color: '#aaa', fontStyle: 'italic' }}>Aucun client</span>
                                        }
                                    </div>
                                </button>
                                {user.role === 'admin' && renderActionsMenu(element, effectiveStatus)}
                            </div>
                        );
                    })}
                </div>
            </div>

            {isOpenCreate && (
                <Popup
                    content={<CreateBedForm />}
                    handleClose={togglePopupCreate}
                />
            )}
            {openDetail && (
                <Popup
                    content={<DetailBedForm bed={openDetail} />}
                    handleClose={() => togglePopupDetail(null)}
                />
            )}
        </div>
    );
}

export default BedsData;
